import React, { useCallback, useEffect, useState } from "react";
import { useHistory, useRouteMatch } from "react-router";
import fp from "lodash/fp";
import queryParamsParse from "./queryParamsParse";
import queryParamsStringify from "./queryParamsStringify";

const useQueryParams = (props) => {
    const history = useHistory();
    const match = useRouteMatch();

    const [queryParams, setQueryParams] = useState(queryParamsParse(fp.get("location.search", history)));

    useEffect(() => {
        const queryPrams_ = queryParamsParse(fp.get("location.search", history));
        setQueryParams(queryPrams_);
    }, [history.location.search]);

    const pushHistory = useCallback(
        ({ url, params }) => {
            if (!params) throw new Error("params is required");
            const queryParamsString = queryParamsStringify(params, { addQueryPrefix: true });
            const url_ = url ? url : match.url;
            history.push(`${url_}${queryParamsString}`);
        },
        [match],
    );

    const replaceHistory = useCallback(
        ({ url, params }) => {
            if (!params) throw new Error("params is required");
            const queryParamsString = queryParamsStringify(params, { addQueryPrefix: true });
            const url_ = url ? url : match.url;
            history.replace(`${url_}${queryParamsString}`);
        },
        [match],
    );

    const queryParams_ = {
        history,
        action: history.action,
        queryParams,
        pushHistory,
        replaceHistory,
    };

    return queryParams_;
};

export default useQueryParams;
